import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as ProjectAPI from './projectAPI';

export const writeProject = createAsyncThunk('projectWrite/write', async ({ title, body, tags }, { rejectWithValue }) => {
    try {
        const response = await ProjectAPI.writeProject({ title, body, tags });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const updateProject = createAsyncThunk('projectWrite/update', async ({ id, title, body, tags }, { rejectWithValue }) => {
    try {
        const response = await ProjectAPI.updateProject({ id, title, body, tags });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const initialState = {
    title: '',
    body: {},
    tags: [],
    project: null,
    projectError: null,
    originalProjectId: null,
    user: null,
};

const projectWriteSlice = createSlice({
    name: 'projectWrite',
    initialState,
    reducers: {
        initialize: state => initialState,
        changeField: (state, { payload: { key, value }}) => {
            state[key] = value;
        },
        setOriginalProject: (state, { payload: project }) => {
            state.title = project.title;
            state.body = project.body;
            state.tags = project.tags;
            state.originalProjectId = project._id;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(writeProject.fulfilled, (state, { payload }) => {
                state.project = payload;
                state.projectError = null;
            })
            .addCase(writeProject.rejected, (state, { payload }) => {
                state.project = null;
                state.projectError = payload;
            })
            .addCase(updateProject.fulfilled, (state, { payload }) => {
                state.project = payload;
                state.projectError = null;
            })
            .addCase(updateProject.rejected, (state, { payload }) => {
                state.project = null;
                state.projectError = payload;
            })
    }
});

// 액션과 리듀서 내보내기
export const { initialize, changeField, setOriginalProject } = projectWriteSlice.actions;
export default projectWriteSlice.reducer;